import { render } from "./ArrowRight.vue?vue&type=template&id=0dfedc2e&ts=true"
import script from "./ArrowRight.vue?vue&type=script&lang=ts"
export * from "./ArrowRight.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__